import { Input } from 'antd'
import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const PageWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  background: #fffafa;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Logo = styled.img`
  position: absolute;
  top: 24px;
  left: 32px;
  width: 40px;
  height: 40px;
  z-index: 10;
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ProfilesWrapper = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1200px;
  padding: 20px;
`

export const ProfileItem = styled.div`
  width: 147px;
  height: 143px;
  border-radius: 147px;
  background: #007f7c;
  cursor: pointer;
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;

  &:hover {
    transform: scale(1.08);
  }
`

export const LoadingText = styled.div`
  position: absolute;
  bottom: 40px;
  font-size: 18px;
  color: #444;
`

export const LoginBox = styled.div`
  width: 440px;
  background: var(--background-color);
  padding: 40px;
  border-radius: 14px;
  box-shadow: var(--box-shadow);
`

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`

export const LoginDetails = styled.div`
  width: 100%;
`

export const InputWrapper = styled.div`
  margin-bottom: 12px;
`

export const Label = styled.div`
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: 500;
`

export const ErrorWrapper = styled.div`
  color: red;
  font-size: 13px;
  margin-top: 6px;
`

export const ButtonWrapper = styled.div`
  margin-top: 20px;
`
export const StyledInput = styled(Input)`
  &::placeholder {
    color: #007f7c !important;
  }

  /* Ensures cross-browser support */
  &::-webkit-input-placeholder {
    color: #007f7c !important;
  }
  &:-ms-input-placeholder {
    color: #007f7c !important;
  }
`
